module.exports = __webpack_public_path__ + "img/board-star-4th.0445b247.svg";